/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg word length`)
};

const es_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud promedio de palabras`)
};

const de_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschnittliche Wortlänge`)
};

const nl_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemiddelde woordlengte`)
};

const fr_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur moyenne des mots`)
};

const it_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza media delle parole`)
};

const pt_br2_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento médio das palavras`)
};

const pt_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento médio de palavras`)
};

const ja_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均単語長`)
};

const zh_wc_avg_word_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均词长`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_avg_word_length = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_avg_word_length(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_avg_word_length", locale)
	if (locale === "en") return en_wc_avg_word_length(inputs)
	if (locale === "es") return es_wc_avg_word_length(inputs)
	if (locale === "de") return de_wc_avg_word_length(inputs)
	if (locale === "nl") return nl_wc_avg_word_length(inputs)
	if (locale === "fr") return fr_wc_avg_word_length(inputs)
	if (locale === "it") return it_wc_avg_word_length(inputs)
	if (locale === "pt-BR") return pt_br2_wc_avg_word_length(inputs)
	if (locale === "pt") return pt_wc_avg_word_length(inputs)
	if (locale === "ja") return ja_wc_avg_word_length(inputs)
	return zh_wc_avg_word_length(inputs)
};